import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor} from '@angular/forms';
import {DomainModel, DomainSelectTranslation} from '../../translation.models';
import {DomainService} from '../../Services/domain-service.service';

@Component({
  selector: 'app-domain-select',
  templateUrl: './domain-select.component.html',
  styleUrls: ['./domain-select.component.scss']
})

export class DomainSelectComponent implements OnInit, ControlValueAccessor {
  /** Domain objects */
  public domains: DomainModel[];
  /** Current selected value */
  private _value: number;
  /** Show Empty option */
  @Input() showEmpty = true;
  /** Select First item at load */
  @Input() selectFirstItem = false;
  /** Component disability */
  @Input() disabled = false;
  /** Component translation */
  @Input() translation: DomainSelectTranslation;
  /** onChange event */
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  /** onError event */
  @Output() onError: EventEmitter<any> = new EventEmitter();

  /**
   * @param {DomainService} domainService
   */
  constructor(private domainService: DomainService) {}

  /**
   * Initialize component.
   * Apply translations.
   * Retrieve domain list from server
   */
  ngOnInit() {
    this.translation = Object.assign({
      placeholder: 'Domain'
    }, this.translation);
    this.domainService.list().subscribe(data => {
      this.domains = data.domains;
      if (this.selectFirstItem) {
        this.OnChanges(this.domains[0].id);
      }
    }, error => {
      this.onError.next(error);
    });
  }

  /**
   * Receive changes from angular model
   * @param changes
   * @constructor
   */
  OnChanges(changes: number) {
    this.writeValue(changes);
    this.onChange.next(changes);
  }

  /** Touch callback */
  onTouched = () => {};

  /** Current value */
  get value(): number {
    return this._value;
  }

  /** Set current value */
  set value(language: number) {
    this.writeValue(language);
  }

  /** Set current value */
  writeValue(language: number): void {
    this._value = language;
  }

  /** @inheritDoc */
  registerOnChange(fn: (domain: number) => void): void {
    this.onChange.subscribe(fn);
  }

  /** @inheritDoc */
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  /** set disability state of component */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
